<template>
  <card>
    <list
      v-if="$store.state.user.sections['personal/dealers']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_personal_dealer",
      itemLink: "personal/dealers",
      setLink: "personal/dealers",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "phone",
          title: "Контактный номер",
        },
        {
          key: "tin",
          title: "ИНН",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
